module.exports = __webpack_public_path__ + "media/images/flags/64/Belarus-6eb9ec97bbb5ae50069e8a7f6bdc6824.png";